import { useState } from 'react';
import { useNavigate, Link, Navigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { useSystemAdminRegisterAvailable } from '../../hooks/queries/authQueries';
import { ROUTES, STORAGE_KEYS } from '../../utils/constants';
import './Login.css';
import EyeIcon from '../../assets/icons/eye.svg?react';
import EyeOffIcon from '../../assets/icons/eye-off.svg?react';
import loginBackground from '../../assets/images/loginbackground.svg'

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login, loading, error: authError } = useAuthContext();
  const navigate = useNavigate();
  
  // 토큰이 없을 때만 시스템 관리자 존재 여부 확인
  const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) || localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const { data: systemAdminStatus, isLoading: isCheckingSystemAdmin } = useSystemAdminRegisterAvailable(!accessToken);
  
  // 시스템 관리자 존재 여부에 따라 리다이렉트 (렌더링 전에 처리)
  if (!accessToken && !isCheckingSystemAdmin && systemAdminStatus?.status === true) {
    // 시스템 관리자가 없으면 시스템 로그인 페이지로 이동
    return <Navigate to={ROUTES.SYSTEM_LOGIN} replace />;
  }
  
  // 시스템 관리자 확인 중일 때는 아무것도 렌더링하지 않음
  if (!accessToken && isCheckingSystemAdmin) {
    return null;
  }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // 입력 시 에러 메시지 초기화
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.email || !formData.password) {
      setError('이메일과 비밀번호를 모두 입력해주세요.');
      return;
    }

    try {
      const result = await login(formData);
      if (result.success) {
        navigate('/'); // 로그인 성공 시 메인 페이지로 이동
      } else {
        setError(result.error || '로그인에 실패했습니다.');
      }
    } catch (error) {
      setError('로그인 중 오류가 발생했습니다.');
    }
  };

  return (
    <div className="login-container">
      {/* 왼쪽 파란색 배경 영역 */}
      <div className="login-left-section">
        <img src={loginBackground} alt="login background" className="absolute top-0 left-0 w-full h-full object-cover z-0" />
      </div>
      
      {/* 오른쪽 로그인 폼 영역 */}
      <div className="login-right-section">
        <div className="login-form-container">
          <div className="login-header">
            <h1 className="text-h1 text-gray-900">회원 로그인</h1>
            <p className="text-b2-400 text-gray-600">한국동서발전 전기차 충전모니터링 시스템에 오신 것을 환영합니다.</p>
          </div>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email" className="text-b2-700 text-gray-700">이메일</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="이메일을 입력해주세요"
                className="w-full input-primary big-input"
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password" className="text-b2-700 text-gray-700">비밀번호</label>
              <div className="relative">
                <input
                  className="w-full input-primary big-input"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="비밀번호를 입력해주세요"
                  required
                />
                <button 
                  type="button"
                  className="password-toggle-btn" 
                  onClick={(e) => {
                    e.preventDefault();
                    setShowPassword(!showPassword);
                  }}
                >
                  {showPassword ? <EyeOffIcon color="var(--gray-800)" /> : <EyeIcon color="var(--gray-800)" />}
                </button>
              </div>
            </div>
            
            {(error || authError) && (
              <div className="error-message">
                {"로그인에 실패하였습니다"}
              </div>
            )}
            
            <button 
              type="submit" 
              className="login-button"
              disabled={loading}
            >
              {loading ? '로그인 중...' : '로그인 하기'}
            </button>
          </form>
          
        </div>
      </div>
    </div>
  );
};

export default Login;